import styled from 'styled-components';
import {styledByDevice} from '../../../../../themes/architecture/styled-by-device';
import {GeneralTitleDefaultBox} from '../../../../../basic-components/general-title/general-title.default.box';

//.general-title
export const DefaultBox = styled(GeneralTitleDefaultBox)`
    color: ${props => props.theme.colors.textLight};
    border-left: 2px solid ${props => props.theme.colors.textLight};
    ${({theme}) => theme.font.presets.bold};

    margin: 0;
    margin-bottom: 10px;
`;



export const PcBox = styled(DefaultBox)`
    font-size: 1.2rem;
    padding-left: 0.8rem;
`;

export const MobileBox = styled(DefaultBox)`
    font-size: 1.4rem;
    padding-left: 2rem;
`;

export const SectionTitleDefaultBox = styledByDevice(PcBox, MobileBox);